import { JsonObject, JsonProperty } from "json2typescript";


@JsonObject("ProcessingRun")
export class ProcessingRun {

  static equals(a: ProcessingRun, b: ProcessingRun): boolean {
    if (a == null || b == null) {
      return false;
    }

    return a.guid == b.guid && a.id == b.id;
  }

  @JsonProperty("guid", String, false)
  public guid: string = null;

  @JsonProperty("id", String, false)
  public id: string = null;


}
